import { apiFetch } from "@/lib/api";

import type { KittingCartSlot } from "./kittingCartModel";
import type { KittingCartLetter, KittingCartMark } from "./kittingCartMarks";

export type KittingCartLabelPrintInput = {
  kind: KittingCartSlot["kind"];
  titleLine: string;
  summaryLine: string;
  routeLine: string | null;
  dueHint: string | null;
  slotKey: string;
  deliveryStationName?: string | null;
  cartLetter?: KittingCartLetter | null;
};

export function kittingCartLabelPayloadFromSlot(
  slot: KittingCartSlot,
  mark?: KittingCartMark | null,
): KittingCartLabelPrintInput {
  return {
    kind: slot.kind,
    titleLine: slot.titleLine,
    summaryLine: slot.summaryLine,
    routeLine: slot.routeLine,
    dueHint: slot.dueHint,
    slotKey: slot.slotKey,
    deliveryStationName: slot.deliveryStationName,
    cartLetter: mark?.letter ?? null,
  };
}

export async function printKittingCartLabels(body: {
  printer: string;
  labels: KittingCartLabelPrintInput[];
}): Promise<{ printed: true; labelCount: number }> {
  return apiFetch<{ printed: true; labelCount: number }>("/api/manufacturing/kitting/label/print", {
    method: "POST",
    body,
  });
}
